import React, { Component, Fragment } from "react";
import { getFormValues, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import { connect } from "react-redux";

import NumberField from "modules/forms/fields/number-field";
import TextField from "modules/forms/fields/text-field";
import SelectField from "modules/forms/fields/select-field";
import constants from "../../common/constants";
import BrandHelper from "../brand/brand-helper";
import { validateSignUp } from "modules/utils/validations";
import { mapFrontendLocaleToBackendLocale } from "../i18n/locale-utils";

export const FORM_NAME = "create-account";

class CreateAccountForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onFacebookSignUp: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    onChangeEmail: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      brand: BrandHelper.getMyDomainObject()
    };
  }

  componentWillMount() {
    const { brand } = this.state;
    this.props.initialize({ customer_id: brand.clinicId });
  }
  render() {
    const { brand } = this.state;
    const {
      onSubmit,
      handleSubmit,
      onChangeEmail,
      onFacebookSignUp
    } = this.props;

    return (
      <form className="signUpForm" onSubmit={handleSubmit(onSubmit)}>
        <p>
          <FormattedMessage id="sign-up.create-acc" />
        </p>
        {brand.clinicCityEnabled && (
          <Fragment>
            <SelectField
              name="clinic_city"
              defaultSelect="sign-up.clinic_city_default"
              values={constants.clinics}
            />
            <NumberField
              name="customer_id"
              defaultValue={brand.clinicId}
              customClass="hidden"
            />
          </Fragment>
        )}
        {brand.registrationWithEmailEnabled && (
          <TextField
            name="email"
            autoComplete="email"
            placeholder="sign-up.email"
            onChange={onChangeEmail}
          />
        )}
        {brand.registrationWithPhoneEnabled && (
          <TextField
            name="phone"
            autoComplete="phone"
            placeholder="sign-up.phone"
          />
        )}
        <TextField
          name="first_name"
          autoComplete="given-name"
          placeholder="sign-up.first-name"
        />
        <TextField
          name="last_name"
          autoComplete="family-name"
          placeholder="sign-up.last-name"
        />

        <footer
          className={
            brand.additionalSpaceOnRegistrationForm ? "more-space" : ""
          }
        >
          <button className="Button--wide" type="submit">
            <FormattedMessage id="sign-up.sign-up" />
          </button>
        </footer>
      </form>
    );
  }
}
CreateAccountForm = connect((state, { form }) => {
  const values = getFormValues(form)(state);
  // TODO: fix state changing
  if (values) {
    values.language = mapFrontendLocaleToBackendLocale(
      state.localeConfig.locale
    );
  }
  return {
    locale: state.localeConfig.locale
  };
})(CreateAccountForm);

export default injectIntl(
  reduxForm({ form: FORM_NAME, validate: validateSignUp })(CreateAccountForm)
);



// WEBPACK FOOTER //
// ./src/modules/auth/create-account-form.js